import React from 'react';
import { ReactComponent as NothingYetIcon } from '../../../../assets/i/empty.svg';

export const NothingYetMessage = () => {
    return (
        <div className='nothing-yet'>
            <NothingYetIcon />
            <span className="nothing-yet-text">Пока ничего нет</span>
        </div>
    );
};


